import React, { useState, useEffect } from 'react';
import axios from 'axios';
import TypeaheadWrapper from './common/TypeaheadWrapper';

const TaskForm = ({ goalId, taskCategories, goalCategory, fetchGoals }) => {
    const [taskName, setTaskName] = useState('');
    const [taskCategory, setTaskCategory] = useState(goalCategory || '');
    const [taskExpectedTime, setTaskExpectedTime] = useState(0);
    const [taskWeight, setTaskWeight] = useState(1);

    // 根据 goalCategory 初始化 taskCategory 和 taskWeight
    useEffect(() => {
        if (goalCategory) {
            fetchCategoryWeight(goalCategory);
        }
    }, [goalCategory]);

    const fetchCategoryWeight = async (categoryName) => {
        try {
            const response = await axios.get(`/categories/${categoryName}`);
            if (response.data) {
                setTaskCategory(response.data.name);
                setTaskWeight(response.data.weight);
            }
        } catch (error) {
            console.error('Error fetching category weight:', error);
        }
    };

    const addTaskToGoal = async () => {
        try {
            const newTask = {
                task: taskName,
                category: taskCategory,
                expectedTime: taskExpectedTime,
                weight: taskWeight,
                investedTime: 0,
                goal: goalId // 添加 goalId 到 newTask 中
            };
            await axios.post(`/goals/${goalId}/tasks`, newTask);

            // 获取更新后的目标，重新计算总的预期时间
            const goalResponse = await axios.get(`/goals/${goalId}`);
            const updatedGoalExpectedTime = goalResponse.data.tasks.reduce((total, t) => total + (t.expectedTime || 0), 0);
            await axios.put(`/goals/${goalId}`, { ...goalResponse.data, expectedTime: updatedGoalExpectedTime });

            fetchGoals();
            setTaskName('');
            setTaskCategory(goalCategory || '');
            setTaskExpectedTime(0);
            setTaskWeight(1);
        } catch (error) {
            console.error('Error adding task to goal:', error);
        }
    };

    const handleCategoryChange = async (selected) => {
        if (selected.length > 0) {
            const selectedCategoryName = selected[0];
            await fetchCategoryWeight(selectedCategoryName);
        }
    };

    return (
        <div className="input-group mt-3">
            <input
                type="text"
                className="form-control"
                value={taskName}
                onChange={(e) => setTaskName(e.target.value)}
                placeholder="Task Name"
                required
            />
            <TypeaheadWrapper
                id="task-category"
                options={taskCategories}
                selected={taskCategory ? [taskCategory] : []}
                onChange={handleCategoryChange}
                placeholder="Select category"
                required
            />
            <input
                type="number"
                className="form-control"
                value={taskExpectedTime}
                onChange={(e) => setTaskExpectedTime(e.target.value)}
                placeholder="Expected Time (mins)"
                required
            />
            <input
                type="number"
                className="form-control"
                value={taskWeight}
                onChange={(e) => setTaskWeight(parseFloat(e.target.value))}
                placeholder="Weight"
                required
            />
            <button className="btn btn-success" onClick={addTaskToGoal}>Add Task</button>
        </div>
    );
};

export default TaskForm;
